/** Fixed width for platform bar tiles so short and long labels align in a grid. */
export const PUBLISH_PLATFORM_BAR_TILE_WIDTH = 100;

/** Spacing and padding for platform bar tiles. */
export const publishPlatformBarTileSx = {
  width: PUBLISH_PLATFORM_BAR_TILE_WIDTH,
  minWidth: PUBLISH_PLATFORM_BAR_TILE_WIDTH,
  gap: 0.5,
  py: 1,
  px: 0.25,
} as const;
